import { render } from "./TermsConditions.vue?vue&type=template&id=50edcd84&scoped=true"
const script = {}

import "./TermsConditions.vue?vue&type=style&index=0&id=50edcd84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50edcd84"]])

export default __exports__